import { snackbarInfoReducer } from '@mb/redux/slices';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    snackbarInfo: snackbarInfoReducer,
  },
});
